import * as t from "io-ts";
import { UnitInputValueV } from "@/types/unit";

// TODO: Incomplete types

// Helpers
const nullable = <T extends t.Mixed>(type: T) => t.union([type, t.null]);
const nullableString = nullable(t.string);
const nullableNumber = nullable(t.number);

// Define the inner structures for flex_align and grid_align
const AxisAlignment = t.partial({
  primary_axis: nullableString,
  cross_axis: nullableString
});

const Layout = t.partial({
  display: nullableString,
  flex_direction: nullableString,
  grid_auto_flow: nullableString,
  flex_align: nullable(AxisAlignment),
  grid_align: nullable(AxisAlignment)
});

const Size = t.partial({
  width: UnitInputValueV,
  height: UnitInputValueV,
  min_width: UnitInputValueV,
  min_height: UnitInputValueV,
  max_width: UnitInputValueV,
  max_height: UnitInputValueV,
  overflow: nullableString,
  box_sizing: nullableString
});

const TypographyStyle = t.partial({
  text_decoration: nullableString,
  font_style: nullableString
});

const Typography = t.partial({
  text_align: nullableString,
  style: nullable(TypographyStyle),
  text_transform: nullableString,
  direction: nullableString,
  text_wrap: nullableString
});

const Effects = t.partial({
  pointer_events: nullableString,
  cursor: nullableString,
  opacity: nullableNumber,
  blend_mode: nullableString,
  transition: t.array(
    t.partial({
      property: nullableString,
      duration: UnitInputValueV,
      easing: nullableString
    })
  )
});

export const ClassPropertiesV = t.partial({
  layout: nullable(Layout),
  size: nullable(Size),
  typography: nullable(Typography),
  effects: nullable(Effects)
});

export type ClassProperties = t.TypeOf<typeof ClassPropertiesV>;
